import domReady from '@wordpress/dom-ready';

import { setViewportUnits, PlayVideoInViewportOnly, EditableSvg, scrollToHash, initHeaderHeight } from './utils/utilities.js';
import { Offcanvas } from './global/offcanvas';
import { Header } from './global/header';
import './global/modal';
import { Video } from './global/videos.js';
import { DropdownMenu } from './global/dropdownMenu';
import { Facet } from './global/facet.js';
import { ResourceFeed } from './blocks/resource-feed.js';
import { BlockGridCarousel } from './blocks/block-grid.js';
import { Stats } from './blocks/stats.js';

domReady(async () => {
    setViewportUnits();

    scrollToHash();

    initHeaderHeight();

    Array.from(document.querySelectorAll('.editable-svg')).map((img) => EditableSvg(img));

    // stop autoplay video when out of viewport
    Array.from(document.querySelectorAll('video[autoplay]')).map((video) => PlayVideoInViewportOnly(video));

    Header(document.querySelector('.site-header'));

    DropdownMenu();

    const offcanvas = document.querySelector('.offcanvas');
    if (offcanvas) {
        new Offcanvas(offcanvas);
    }

    // blocks
    ResourceFeed();
    Video();
    BlockGridCarousel();
    Stats();

    Facet();

    document.addEventListener('facetwp-loaded', function () {
        ResourceFeed();
    });
});

import.meta.glob([
    '../../images/**',
    '!../../images/cms/**',
    '../../fonts/**',
]);
